import
{
    COACHINGDASHBOARD_LOAD,
    COACHINGDASHBOARD_UNLOAD,
    COACHINGDASHBOARD_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
    startDate: undefined,
    endDate: undefined,
};

const handlers = {
    [COACHINGDASHBOARD_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [COACHINGDASHBOARD_UNLOAD]: () => initialState,
    [COACHINGDASHBOARD_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
